import React, { useEffect, useState, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from '@material-ui/icons/Info';
import RefreshIcon from "@material-ui/icons/Autorenew";
import Loader from "@components/loader";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import { useStore } from "@store/store";
import Header from "@components/header";
import { routes, fsBackDatedStatus, timezone } from "@utils/constant";
import {
  GET_SURCHARGE_BACK_DATED_EVENT_BY_ID,
  GET_SURCHARGE_BACK_DATED_EVENT_BY_ID_SUCCESS,
  GET_SURCHARGE_BACK_DATED_EVENT_BY_ID_FAILURE,
  FETCH_IMPACT_JOBS,
  FETCH_IMPACT_JOBS_SUCCESS,
  FETCH_IMPACT_JOBS_FAILURE,
  FETCH_IMPACT_INVOICES,
  FETCH_IMPACT_INVOICES_SUCCESS,
  FETCH_IMPACT_INVOICES_FAILURE,
  REFRESH_IMPACTED_JOB_AND_INVOICE,
  REFRESH_IMPACTED_JOB_AND_INVOICE_SUCCESS,
  REFRESH_IMPACTED_JOB_AND_INVOICE_FAILURE,
  RE_CALCULATE_JOB_CHARGES,
  RE_CALCULATE_JOB_CHARGES_SUCCESS,
  RE_CALCULATE_JOB_CHARGES_FAILURE,
  RE_GENERATE_DRAFT_INVOICES,
  RE_GENERATE_DRAFT_INVOICES_SUCCESS,
  RE_GENERATE_DRAFT_INVOICES_FAILURE,
  UPDATE_STATUS_TO_CHANGED_APPLIED,
  UPDATE_STATUS_TO_CHANGED_APPLIED_SUCCESS,
  UPDATE_STATUS_TO_CHANGED_APPLIED_FAILURE,
  AUTO_UPDATE_NEW_INVOICE_DATE,
  AUTO_UPDATE_NEW_INVOICE_DATE_SUCCESS,
  AUTO_UPDATE_NEW_INVOICE_DATE_FAILURE
} from "@utils/actionTypes";
import API from "@services/axios";
import { BackDatedEventDetailStyle } from "./style";
import { Box, Button, Typography } from "@material-ui/core";
import ImpactedJobsTableListing from "./impacted-jobs-table-listing";
import ImpactedInvoicesTableListing from "./impacted-invoices-table-listing";
import moment from "moment";
import { toast } from "react-toastify";
import { utcToTimezone } from "../../utils/commonFunctions";
import ConfirmJobChargesPopup from "./confirm-job-charges-popup";
import ConfirmDraftInvoicesPopup from "./confirm-draft-invoices-popup";
import ConfirmRefreshJobChargesPopup from "./confirm-refresh-job-charges-popup";
import AlertPopup from "@components/alertPopup";

function BackDatedEventDetail() {
  const classes = BackDatedEventDetailStyle();
  const { id } = useParams();
  const history = useHistory();
  const [state, dispatch] = useStore();
  const [showJobChargePopup, setShowJobChargePopup] = useState(false);
  const [showRefreshJobChargePopup, setShowRefreshJobChargePopup] = useState(false);
  const [showInvoicePopup, setShowInvoicePopup] = useState(false);
  const data = state?.customer?.surchargeBackDatedEventByIdData || {};
  const timezoneCustomer = data.cities?.timezone || "Australia/Sydney";
  const status = state?.customer?.surchargeBackDatedEventByIdData?.status || "";
  const [listNewInvoiceDateMap, setListNewInvoiceDateMap] = useState(new Map());
  const [disabledRefresh, setDisabledRefresh] = useState(false);
  const [isSpinRefresh, setIsSpinRefresh] = useState(false);
  const [openAlertPopup, setAlertPopup] = useState(false);
  const [showJobRecalculateAlert, setShowJobRecalculateAlert] = useState(false);
  const [firstErrorInvoiceId, setFirstErrorInvoiceId] = useState(null);
  const errorRefs = useRef(new Map());

  useEffect(() => {
    setDisabledRefresh(status !== fsBackDatedStatus.pendingReview);
  }, [status]);

  useEffect(() => {
    if (!state?.customer?.loadingSurchargeBackDatedEventById
      && !state?.customer?.loadingImpactJob
      && !state?.customer?.loadingImpactInvoice) {
      setIsSpinRefresh(false);
      if (showJobRecalculateAlert) {
        setAlertPopup(true);
      }
    }
  }, [
    state?.customer?.loadingSurchargeBackDatedEventById,
    state?.customer?.loadingImpactJob,
    state?.customer?.loadingImpactInvoice
  ])

  useEffect(() => {
    if (firstErrorInvoiceId && errorRefs.current.has(firstErrorInvoiceId)) {
      const el = errorRefs.current.get(firstErrorInvoiceId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.focus?.();
      }
    }
  }, [firstErrorInvoiceId, listNewInvoiceDateMap]);

  const getSurchargeBackDatedEventById = () => {
    dispatch({ type: GET_SURCHARGE_BACK_DATED_EVENT_BY_ID });
    API.get(`customers/surchargeBackDatedEvent/${id}`)
      .then((response) => {
        dispatch({
          type: GET_SURCHARGE_BACK_DATED_EVENT_BY_ID_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: GET_SURCHARGE_BACK_DATED_EVENT_BY_ID_FAILURE, payload: error });
        if (error?.response?.status === 404) {
          history.push(routes.pageNotFound);
        }
      });
  };

  const getImpactJobBySurchargeBackDatedEventId = (payload = null) => {
    const params = payload || undefined;
    dispatch({ type: FETCH_IMPACT_JOBS });
    API.get(`customers/surchargeBackDatedEvent/${id}/impactJob`, { params })
      .then((response) => {
        dispatch({
          type: FETCH_IMPACT_JOBS_SUCCESS,
          payload: response.data.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_IMPACT_JOBS_FAILURE, payload: error });
      });
  };

  const getImpactInvoiceBySurchargeBackDatedEventId = (payload = null) => {
    const params = payload || undefined;
    setListNewInvoiceDateMap(new Map());
    dispatch({ type: FETCH_IMPACT_INVOICES });
    API.get(`customers/surchargeBackDatedEvent/${id}/impactInvoice`, { params })
      .then((response) => {
        dispatch({
          type: FETCH_IMPACT_INVOICES_SUCCESS,
          payload: response.data.data,
        });

        response.data.data?.rows?.forEach((invoice) => {
          setListNewInvoiceDateMap(prevMap => {
            const newMap = new Map(prevMap);
            newMap.set(invoice.invoiceId, {date: invoice?.newInvoiceDate ? new Date(invoice?.newInvoiceDate) : null, errorDate: ""});
            return newMap;
          });
        })
      })
      .catch((error) => {
        dispatch({ type: FETCH_IMPACT_INVOICES_FAILURE, payload: error });
      });
  };

  const fetchData = () => {
    getSurchargeBackDatedEventById();
    getImpactJobBySurchargeBackDatedEventId();
    getImpactInvoiceBySurchargeBackDatedEventId();
  };

  const refreshJobAndInvoiceImpacted = async () => {
    setShowRefreshJobChargePopup(false);
    setIsSpinRefresh(true);
    dispatch({ type: REFRESH_IMPACTED_JOB_AND_INVOICE });
    try {
      const response = await API.put(`customers/${id}/refreshImpactedJobsAndInvoices`);
      dispatch({ type: REFRESH_IMPACTED_JOB_AND_INVOICE_SUCCESS });
      toast.success(response.data.message || "Refreshed impacted jobs and invoices successfully.");
      fetchData();
    } catch (error) {
      dispatch({ type: REFRESH_IMPACTED_JOB_AND_INVOICE_FAILURE });
      toast.error(error?.response?.data?.message || "Failed to refresh impacted jobs and invoices.");
      setIsSpinRefresh(false);
    }
  };

  const reCalculateJobCharges = async () => {
    // Check Current Date > Created Event Date
    const nowUTC = moment().utc().format("YYYY-MM-DD");
    const updatedAtUTC = moment.utc(data?.updatedAt).format("YYYY-MM-DD");
    if (nowUTC > updatedAtUTC) {
      setShowRefreshJobChargePopup(true);
      return;
    }

    dispatch({ type: RE_CALCULATE_JOB_CHARGES });
    try {
      setShowJobRecalculateAlert(false);
      const response = await API.put(`customers/${id}/reCalculateJobCharge`);
      dispatch({ type: RE_CALCULATE_JOB_CHARGES_SUCCESS });
      toast.success(response.data.message);
      if (state?.customer?.impactInvoiceData?.rows?.length > 0) {
        const shouldContinue = Array.from(listNewInvoiceDateMap.values()).every(value => !!value.date);
        if (!shouldContinue) {
          setShowJobRecalculateAlert(true);
        }
      } else {
        setShowJobChargePopup(false);
        await updateStatusToChangeApplied();
      }
      fetchData();
    } catch (error) {
      dispatch({ type: RE_CALCULATE_JOB_CHARGES_FAILURE });
      toast.error(error?.response?.data?.message);
    }
  };

  const reGenerateDraftInvoices = async () => {
    dispatch({ type: RE_GENERATE_DRAFT_INVOICES });
    try {
      const response = await API.put(`customers/${id}/reGenerateDraftInvoices`, {
        listNewInvoiceDateMap: Array.from(listNewInvoiceDateMap?.entries())
      });
      dispatch({ type: RE_GENERATE_DRAFT_INVOICES_SUCCESS });
      setShowInvoicePopup(false);
      setShowJobRecalculateAlert(false);
      toast.success(response.data.message);
      fetchData();
    } catch (error) {
      dispatch({ type: RE_GENERATE_DRAFT_INVOICES_FAILURE });
      toast.error(error?.response?.data?.message);
    }
  };

  const updateStatusToChangeApplied = async () => {
    dispatch({ type: UPDATE_STATUS_TO_CHANGED_APPLIED });
    try {
      const response = await API.put(`customers/${id}/updateStatusToChangeApplied`);
      dispatch({ type: UPDATE_STATUS_TO_CHANGED_APPLIED_SUCCESS });
      setShowInvoicePopup(false);
      setShowJobChargePopup(false);
      setShowJobRecalculateAlert(false);
      toast.success(response.data.message);
      fetchData();
    } catch (error) {
      dispatch({ type: UPDATE_STATUS_TO_CHANGED_APPLIED_FAILURE });
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const formatDateToTimezone = (date) => {
    return date ? utcToTimezone(date, timezone.SYDNEY, "DD-MM-YYYY HH:mm") + " NSW" : "N/A";
  }

  const handleChangeInvoiceDate = async (date, invoiceId) => {
    setListNewInvoiceDateMap(prevMap => {
      const newMap = new Map(prevMap);
      newMap.set(invoiceId, {date: date, errorDate: ""});
      return newMap;
    });

    dispatch({ type: AUTO_UPDATE_NEW_INVOICE_DATE });
    try {
      await API.put(`customers/${id}/autoUpdateNewInvoiceDate`, {
        invoiceId,
        newInvoiceDate: moment(date).format("YYYY-MM-DD")
      });
      dispatch({ type: AUTO_UPDATE_NEW_INVOICE_DATE_SUCCESS });
    } catch (error) {
      dispatch({ type: AUTO_UPDATE_NEW_INVOICE_DATE_FAILURE });
    }
  }

  const handleOpenReGenerateDraftInvoices = () => {
    let isSubmit = true;
    if (state?.customer?.impactInvoiceData?.rows?.length > 0) {
      const updatedInvoiceMap = new Map();
      let firstErrorInvoiceId = null;

      listNewInvoiceDateMap.forEach((value, key) => {
        if (!value.date) {
          isSubmit = false;
          updatedInvoiceMap.set(key, { ...value, errorDate: "New Invoice Date is required" });

          if (!firstErrorInvoiceId) {
            firstErrorInvoiceId = key;
          }
        } else {
          updatedInvoiceMap.set(key, value);
        }
      });
      setListNewInvoiceDateMap(updatedInvoiceMap);
      setFirstErrorInvoiceId(firstErrorInvoiceId);
    }

    if (isSubmit) {
      setShowInvoicePopup(true);
    }
  }

  const registerErrorRef = (invoiceId, element) => {
    if (element) {
      errorRefs.current.set(invoiceId, element);
    }
  };

  const handleCloseAlertPopup = () => {
    setAlertPopup(false);

    const updatedInvoiceMap = new Map();
    let firstErrorInvoiceId = null;

    listNewInvoiceDateMap.forEach((value, key) => {
      if (!value.date) {
        updatedInvoiceMap.set(key, { ...value, errorDate: "New Invoice Date is required" });

        if (!firstErrorInvoiceId) {
          firstErrorInvoiceId = key;
        }
      } else {
        updatedInvoiceMap.set(key, value);
      }
    });
    setListNewInvoiceDateMap(updatedInvoiceMap);
    setFirstErrorInvoiceId(firstErrorInvoiceId);
  }

  return (
    <>
      <Header />
      <ConfirmJobChargesPopup
        open={showJobChargePopup}
        handleClose={() => setShowJobChargePopup(false)}
        handleConfirm={updateStatusToChangeApplied}
      />
      <ConfirmRefreshJobChargesPopup
        open={showRefreshJobChargePopup}
        handleClose={() => setShowRefreshJobChargePopup(false)}
        handleConfirm={refreshJobAndInvoiceImpacted}
        createdDate={utcToTimezone(data?.updatedAt, timezone.SYDNEY, "DD-MM-YYYY")}
      />
      <ConfirmDraftInvoicesPopup
        open={showInvoicePopup}
        handleClose={() => setShowInvoicePopup(false)}
        handleConfirm={updateStatusToChangeApplied}
        reGenerateDraftInvoices={reGenerateDraftInvoices}
      />
      <AlertPopup
        open={openAlertPopup}
        handleClose={handleCloseAlertPopup}
        error={"Please input the new invoice date(s) and try again."}
        title={"Invoice Date Required"}
        bigSize={true}
      />
      <div className={classes.BackDatedEventDetailWrapper}>
        <Loader
          loading={
            state?.customer?.loadingSurchargeBackDatedEventById ||
            state?.customer?.loadingImpactJob ||
            state?.customer?.loadingImpactInvoice ||
            state?.customer?.refreshingImpactedJobAndInvoice ||
            state?.customer?.loadingReCalculateJobCharges ||
            state?.customer?.loadingReGenerateDraftInvoices ||
            state?.customer?.loadingUpdateStatusToChangedApplied ||
            state?.customer?.loadingAutoUpdateNewInvoiceDate
          }
        />
        <div className="wrapper">
          <div className="inner-page">
            <div className={classes.backLinkWrapper}>
              <Link to={routes.backDatedEvents} className={classes.backToPage}>
                <ArrowBackIosIcon /> Back to Impacted Customers
              </Link>
            </div>
            <div className={classes.innerPageTopBlock}>
              <div className="left-block">
                <Typography variant="h1">Review Back-Dated Fuel Surcharge</Typography>
              </div>
              <div className="right-block">
                <div className="right-block-inner">
                  <div>
                    <Button
                      onClick={reCalculateJobCharges}
                      color="primary"
                      className="orange-btn primary-btn"
                      disabled={status !== fsBackDatedStatus.pendingReview}
                    >
                      Re-calculate job charges
                    </Button>
                  </div>
                  <div style={{ marginLeft: "10px" }}>
                    <Button
                      onClick={handleOpenReGenerateDraftInvoices}
                      color="primary"
                      className="orange-btn primary-btn center-loading-indicator"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                      disabled={status !== fsBackDatedStatus.processing || state?.customer?.impactInvoiceData?.rows?.length === 0}
                    >
                      Re-generate draft invoices
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="detail-col-layout">
              {data?.customers && (
                <Box className={classes.changeSummaryBox}>
                  <Typography variant="subtitle1" className="title">Change Summary</Typography>

                  <Box className={classes.summaryContent}>
                    <Box className={classes.summaryItem}>
                      <Typography variant="body2">Customer / City:</Typography>
                      <Typography variant="body1"><strong>{data?.customers?.name + ' - ' + data?.cities?.name}</strong></Typography>
                    </Box>

                    <Box className={classes.summaryItem}>
                      <Tooltip title={"This rate applies to all jobs with a completion date on or after the start date. The effectiveness is calculated from 00:00 on this date, regardless of the time it was entered."} arrow placement="top">
                        <Typography variant="body2">Impacted Period:</Typography>
                      </Tooltip>
                      <Box display="flex" alignItems="center">
                        <Typography variant="body1">
                          <strong>
                            {moment(data?.impactPeriodStart).format("DD-MM-YYYY")} to{' '}
                            {moment(data?.fuelSurcharges?.endDate ?? moment()).format("DD-MM-YYYY")}
                          </strong>
                        </Typography>
                        <Tooltip title="Refresh impacted period" arrow>
                          <RefreshIcon
                            fontSize="medium"
                            className={isSpinRefresh ? classes.spin : ""}
                            style={{
                              marginLeft: 6,
                              color: disabledRefresh ? "#ccc" : "#007bff",
                              cursor: disabledRefresh ? "not-allowed" : "pointer",
                              pointerEvents: disabledRefresh ? "none" : "auto"
                            }}
                            onClick={disabledRefresh ? null : refreshJobAndInvoiceImpacted}
                          />
                        </Tooltip>
                      </Box>
                    </Box>
                    <Box className={classes.summaryItem}>
                      <Typography variant="body2">Fuel Surcharge Rate:</Typography>
                      <Typography variant="body1" style={{ fontWeight: "bold", color: "green" }}>{data?.fuelSurcharges?.fuelSurcharge || "0"}%</Typography>
                    </Box>

                    <Box className={classes.summaryItem}>
                      <Typography variant="body2">Last Update:</Typography>
                      <Typography variant="body1"><strong>{data?.updatedAt ? formatDateToTimezone(data?.updatedAt) : ""}</strong></Typography>
                    </Box>
                  </Box>
                </Box>
              )}
              {state?.customer?.impactJobData?.rows && state?.customer?.impactJobData?.rows.length > 0 && (
                <>
                  <Box className={classes.sectionHeader}>
                    <Typography variant="h2">
                      Impacted Jobs
                      <Tooltip
                        title="Jobs that fall within the impacted period but not yet invoiced. Their charges will be re-calculated based on the new rate."
                        arrow
                        placement="right"
                      >
                        <InfoIcon />
                      </Tooltip>
                    </Typography>
                  </Box>
                  <ImpactedJobsTableListing
                    timezone={timezoneCustomer}
                    getImpactJobBySurchargeBackDatedEventId={getImpactJobBySurchargeBackDatedEventId}
                  />
                </>
              )}
              {state?.customer?.impactInvoiceData?.rows && state?.customer?.impactInvoiceData?.rows.length > 0 && (
                <>
                  <Box className={classes.sectionHeader}>
                    <Typography variant="h2">
                      Impacted Invoices
                      <Tooltip
                        title="When an invoice is re-generated, a new draft is created containing only the jobs from the original invoice. Any other jobs that were not on the original invoice will need to be invoiced separately."
                        arrow
                        placement="right"
                      >
                        <InfoIcon />
                      </Tooltip>
                    </Typography>

                  </Box>
                  <ImpactedInvoicesTableListing
                    timezone={timezoneCustomer}
                    getImpactInvoiceBySurchargeBackDatedEventId={getImpactInvoiceBySurchargeBackDatedEventId}
                    listNewInvoiceDateMap={listNewInvoiceDateMap}
                    handleChangeInvoiceDate={handleChangeInvoiceDate}
                    registerErrorRef={registerErrorRef}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default BackDatedEventDetail;
